import { Component } from '@angular/core';
import {ITooltipParams} from "ag-grid-community";
import {ITooltipAngularComp} from "ag-grid-angular";

interface DisplayText{
  line1: string,
  line2: string | null
}

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements ITooltipAngularComp {
  private params!: { col: string} & ITooltipParams;
  public data!: any;
  public col!: string;
  public display: DisplayText = {line1: '', line2: null};

  agInit(params: { col: string} & ITooltipParams): void{
    this.params = params;
    this.data = params.api!.getDisplayedRowAtIndex(params.rowIndex!)!.data;
    this.col = this.params.col;

    if(this.params.col === 'shipper'){
      this.display.line1 = this.data.shipper_locality + ', ' + this.data.shipper_region
      this.display.line2 = 'Pickup Ref #:' + (this.data.pickup_reference_number ? this.data.pickup_reference_number : '');
    }
    else if(this.params.col === 'consignee'){
      this.display.line1 = this.data.consignee_locality + ', ' + this.data.consignee_region;
      this.display.line2 = 'Delivery Ref #:' + (this.data.delivery_reference_number ? this.data.delivery_reference_number : '');
    }
    else if(this.params.col === 'carrier'){
      // displays date, time, timezone (GMT info left out)
      // if default date (Dec 31 1969) shown, display "not set"
      
      if(this.data.load_start.toString().includes('1969'))
        this.display.line1 = 'Pickup date not set'
      else
        this.display.line1 = "Pickup: " + this.data.load_start.toString().substring(0,24) + this.data.load_start.toString().substring(33);

      if(this.data.load_end.toString().includes('1969'))
        this.display.line2 = 'Delivery date not set'
      else 
        this.display.line2 = 'Delivery:' + this.data.load_end.toString().substring(0,24) + this.data.load_end.toString().substring(33);
    }
    else if(this.params.col === 'order_num'){
      this.display.line1 = 'Pieces:' + this.data.load_pieces;
      this.display.line2 = 'Actual Weight:' + this.data.load_weight_actual + (this.data.load_weight_unit ? this.data.load_weight_unit : '');
    }
  }
}
